import Grid from '@material-ui/core/Grid';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const NoAttachmentsLabel = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(2)
}));

export const SubContainer = styled(Grid)(({ theme }) => ({
  overflow: 'hidden'
}));
